import { Link, useLocation } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useDetectApp } from "lib/monoapp";

const GameBGMap = {
  val: "https://static.bigbrain.gg/apps/viper.webm",
  deadlock: "https://static.bigbrain.gg/apps/deadlock_menu_streets_loop2.webm",
  lol: "https://static.bigbrain.gg/assets/lol/backgrounds/irelia_animated_bg.webm",
  wow: "https://static.bigbrain.gg/assets/lol/backgrounds/irelia_animated_bg.webm",
};

const AccountLandingPageLayout = ({ children, aside }) => {
  const isApp = useDetectApp();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gameParam = searchParams.get("game") ?? "lol";
  const videoSrc = GameBGMap[gameParam];
  const isFromCheckout = searchParams.get("continue")?.startsWith(AppRoutes.CHECKOUT);

  return (
    <div className="relative w-full overflow-hidden">
      {/* Animated video background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hidden xs:block fixed top-0 left-0 w-screen h-screen object-cover object-top z-0 pointer-events-none select-none"
        tabIndex={-1}
        aria-hidden="true"
        src={videoSrc}
      />
      {/* Overlay for darkening effect */}
      {gameParam !== "deadlock" && (
        <div
          className="hidden xs:block fixed top-0 left-0 w-screen h-screen z-10 pointer-events-none select-none"
          style={{
            background:
              "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(7,7,32,0.14) 0%, rgba(7,7,32,0.22) 40%, rgba(7,7,32,0.45) 80%, rgba(7,7,32,0.7) 100%), linear-gradient(to bottom, rgba(7,7,32,0.05) 0%, rgba(7,7,32,0.05) 85%, rgba(7,7,32,0.3) 95%, rgba(7,7,32,0.45) 100%)",
          }}
          aria-hidden="true"
          tabIndex={-1}
        />
      )}
      <div className="w-full mt-[20px] xs:mt-[70px] xs:ml-[70px] z-20 relative flex flex-wrap gap-[20px] max-xs:justify-center">
        <div
          className="w-full rounded-[4px] max-w-[396px] pt-[20px] pr-[48px] pb-[48px] pl-[48px]"
          style={{
            background: "rgba(7, 7, 32, 0.4)",
            backdropFilter: "blur(15px)",
            WebkitBackdropFilter: "blur(15px)",
            textAlign: "left",
          }}
        >
          {!isApp && (
            <div className="flex xs:mt-[8px] mb-[24px] text-[14px] text-lavender-50">
              <Link to={isFromCheckout ? AppRoutes.PLUS : AppRoutes.HOME}>
                &lt; {isFromCheckout ? "Back to PLUS" : "Back to Home"}
              </Link>
            </div>
          )}
          <img className="flex mb-[32px] w-[80px]" src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" />
          {children}
        </div>
        {aside}
      </div>
    </div>
  );
};

export default AccountLandingPageLayout;
